import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Spinner = () => (
  <div className="route-loading" role="status" aria-label="Loading">
    <Spin indicator={<LoadingOutlined spin />} size="large" />
  </div>
);

export default Spinner;
